import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import {  MsalInterceptor } from '@azure/msal-angular';
import '@ungap/with-resolvers';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToastModule } from 'primeng/toast';
import { DummyComponent } from './dummy.component';

import {
  AuthModule,
  ArrowModule,
  HeaderModule,
  MainMenuModule,
  MainLayoutModule,
  ReleasenotesModule,
  QUANGULAR_CONFIG,
  LoaderModule,
  AuthRedirectComponent,
  QdsHeaderModule,
  ToasterModule,
  ConfirmDialogModule,
} from 'quangular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SettingsModule } from './modules/settings/settings.module';
import { ConfirmationService, MessageService } from 'primeng/api';
import { config } from './app-menu.config';
@NgModule({
    imports: [
        ReactiveFormsModule,
        FormsModule,
        BrowserAnimationsModule,
        SharedModule,
        ToastModule,
        SettingsModule,

        AuthModule.forRoot(config),
        BrowserModule,
        AppRoutingModule,
        MainLayoutModule,
        HeaderModule,
        QdsHeaderModule,

        ArrowModule,
        LoaderModule,
        MainMenuModule,
        ReleasenotesModule,

        ToasterModule,
        ConfirmDialogModule
    ],
    exports: [
        QdsHeaderModule
    ],
    providers: [
      provideAnimations(),
      MessageService,
      ConfirmationService,
       {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: QUANGULAR_CONFIG,
            useValue: config
        }
    ],
    declarations: [ AppComponent, DummyComponent ],
    bootstrap: [AppComponent, AuthRedirectComponent]
})
export class AppModule { }
 